import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Table from "../components/Table";
import { brandsColumns } from "../data/brands";
import api from "../services/api";
import Modal from "../components/Modal";
import Danger from "../assets/danger-sign.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Brands = () => {
  const [allBrands, setAllBrands] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate =  useNavigate()

  useEffect(() => {
    setLoading(true)
    api.admin.brand
      .getBrands()
      .then((res) => {
        setAllBrands(res.data?.brands);
      })
      .catch((res) => console.log(res))
      .finally(()=>setLoading(false));
  }, []);

  const openModal = (id) => {
    setDeleteId(id);
    setIsModalOpen(true);
  };

  const deleteItem = () => {
    setDeleting(true);
    api.admin.brand
      .deleteBrand(deleteId)
      .then((res) => {
        setAllBrands((prevBrands) =>
          prevBrands.filter((brand) => brand.id !== deleteId)
        );
        toast.success('Brand deleted successfully')
        setIsModalOpen(false);
      })
      .catch(console.error)
      .finally(() => setDeleting(false));
  };

  const editBrand = (id) => {
    navigate(`/brands/add?id=${id}`);
  };

  return (
    <Box sx={{ pt: "80px", pb: "20px" }}>
      <Typography variant="h6" sx={{ marginBottom: "14px" }}>
        Brands
      </Typography>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <Table
          data={allBrands}
          fields={brandsColumns}
          numberOfRows={allBrands?.length}
          enableTopToolBar={true}
          enableBottomToolBar={true}
          enablePagination={true}
          enableRowSelection={true}
          enableColumnFilters={true}
          enableEditing={true}
          enableColumnDragging={true}
          handleDelete={openModal}
          editing={true}
          handleEditing={editBrand}
        />
      )}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <img src={Danger} alt="Danger" style={{ width: "100px" }} />
          <Typography variant="h6">Are you sure you want to delete?</Typography>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "center",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "green",
                "&:hover": {
                  backgroundColor: "darkgreen",
                },
              }}
              disabled={deleting === true}
              onClick={() => deleteItem(deleteId)}
            >
              {deleting ? <CircularProgress /> : "Yes"}
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "red",
                "&:hover": {
                  backgroundColor: "darkred",
                },
              }}
              disabled={deleting === true}
              onClick={() => setIsModalOpen(false)}
            >
              No
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Brands;
